/**
 * Amorçage hors ligne, exécuté une fois avant le premier rendu.
 *
 * Ordre imposé :
 *   1. restaurer l'instantané de l'onglet (profil + écritures en file) — AVANT
 *      que l'AuthGuard n'interroge le cache, sinon il repart vers /login ;
 *   2. rejouer immédiatement les écritures en attente si le réseau est là (cas
 *      du rechargement une fois la connexion revenue) ;
 *   3. maintenir l'instantané à jour pour le prochain rechargement.
 */
import { onlineManager } from "@tanstack/react-query";

import { queryClient } from "@/lib/api/query-client";
import { restoreOfflineSession, watchOfflineSession } from "@/lib/api/offline-session";

restoreOfflineSession(queryClient);

if (onlineManager.isOnline()) {
  void queryClient.resumePausedMutations();
}

watchOfflineSession(queryClient);
